import { render, staticRenderFns } from "./serviceFail.vue?vue&type=template&id=4952978a&"
import script from "./serviceFail.vue?vue&type=script&lang=ts&"
export * from "./serviceFail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports